export default __webpack_public_path__ + "static/media/contour3.6cc6bd6a.svg";